module.exports = __webpack_public_path__ + "img/sedho.2b629521.jpg";